/**
 * This file hosts the professional credentials for:
 * - new purchase
 * - verify professional credentials modal
 * - profile > edit professional credential
 */

export type ProfessionalCredential = string;

const PROFESSIONAL_CREDENTIALS: ProfessionalCredential[] = [
  "Acupuncturist, Licensed",
  "Addiction and Rehabilitation Counselor, Licensed",
  "Art Therapist, Registered, Board Certified",
  "Audiologist, Licensed",
  "Board Certified Behavior Analyst",
  "Certified Coach, (Accredited by International Coaching Federation, ICF)",
  "Certified Craniosacral Therapist",
  "Certified Occupational Therapy Assistant, Licensed",
  "Certified Eye Movement Desensitization & Reprocessing Therapist",
  "Certified Internal Family Systems (IFS) Practitioner",
  "Certified Vision Therapist, Licensed",
  "Certified Yoga Therapist",
  "Chiropractor, Licensed",
  "Dance / Movement / Art Therapist, Registered or Board Certified",
  "Dentists",
  "Developmental and Neuro-Optometric Rehabilitation Optometrist, Licensed",
  "Educator, Licensed",
  "Feldenkrais Practitioner®",
  "Massage Therapist, Licensed",
  "Mental Health Counselor/Therapist Associate",
  "Mental Health Counselor/Therapist, Licensed",
  "Music Therapist, Board Certified",
  "Naturopathic Doctor, Licensed",
  "Neuro-Optometric Rehabilitation Developmental Optometrist, Licensed",
  "Nurse, Licensed",
  "Occupational Therapist, Licensed",
  "Physical Therapist, Licensed",
  "Physical Therapy Assistant, Licensed",
  "Physician Assistant, Licensed",
  "Physician, Licensed",
  "Psychiatrist, Licensed",
  "Psychologist, Licensed",
  "Psychotherapist, Licensed",
  "Recreation Therapist, Licensed",
  "Registered Dietitian",
  "Rolfer® or Structural Integrator",
  "School Counselor, Licensed",
  "Social Worker, Registered or Licensed",
  "Somatic Experiencing Practitioner",
  "Speech Language Pathologist, Licensed",
  "Speech Language Pathology Assistant, Licensed",
  "Veterinarian",
  "Other",
];

// Sort "Other" to the bottom, everything else alphabetically
PROFESSIONAL_CREDENTIALS.sort((a, b) => {
  if (a === "Other") return 1;
  if (b === "Other") return -1;
  return a.localeCompare(b);
});

export { PROFESSIONAL_CREDENTIALS };
